import type {
  SubCompanyResponseDTO,
} from '../../types/previdencia/previdenciaType';
import { PREVIDENCIA_SUBCOMPANIES_ROUTES } from '../requestsService';

export class SubCompanyService {
  private fetch: <T>(endpoint: string, options?: RequestInit) => Promise<T>;

  constructor(fetch: <T>(endpoint: string, options?: RequestInit) => Promise<T>) {
    this.fetch = fetch;
  }

  /**
   * Get subcompanies by company
   * Matches backend endpoint: GET /v1/previdencia/subcompanies
   * @param companyId - Company ID
   */
  async getSubCompanies(companyId: string): Promise<SubCompanyResponseDTO[]> {
    const url = `${PREVIDENCIA_SUBCOMPANIES_ROUTES.GET_SUBCOMPANIES}?companyId=${encodeURIComponent(companyId)}`;

    return this.fetch<SubCompanyResponseDTO[]>(url, {
      method: 'GET',
    });
  }
}

